<template>
  <v-flex>
    <v-row>
      <v-col v-for="plan in plans" :key="plan.id" cols="4">
        <iceverg-plan :plan="plan" :current-plan="currentPlan"></iceverg-plan>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="12">
        <h3 class="text-center">All plans include: </h3>
      </v-col>
      <v-col cols="6">
        <v-list>
          <v-list-item v-for="condition in conditions" :key="condition">
            <v-list-item-icon>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{condition}}
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>

    </v-row>
  </v-flex>
</template>

<script>
  import {icevergPlans} from "../../constants/constants";
  import IcevergPlan from "./icevergPlan";

  export default {
    name: "icevergPlans",
    components: {IcevergPlan},
    props: ['currentPlan', 'quota'],
    data: () => ({
      plans: icevergPlans.plans,
      conditions: icevergPlans.conditions,
    }),
    methods: {
      cancel() {
        this.$emit('cancel', null);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Widgets/icevergPlans.vue